/// <reference types="chrome" />

type ChromeStorageArea = chrome.storage.LocalStorageArea

function getChromeStorage(): ChromeStorageArea | null {
    if (typeof chrome !== 'undefined' && chrome.storage && chrome.storage.local) {
        return chrome.storage.local
    }
    return null
}

export async function getFromChromeStorage<T>(key: string): Promise<T | null> {
    const storage = getChromeStorage()

    if (!storage) return null

    return new Promise((resolve) => {
        storage.get([key], (result) => {
            resolve((result[key] as T) ?? null)
        })
    })
}

export async function setInChromeStorage<T>(key: string, value: T): Promise<void> {
    const storage = getChromeStorage()

    if (!storage) return

    return new Promise((resolve) => {
        storage.set({ [key]: value }, () => resolve())
    })
}